import { render, staticRenderFns } from "./editBankDetails.vue?vue&type=template&id=38b8489a&scoped=true"
import script from "./editBankDetails.vue?vue&type=script&lang=js"
export * from "./editBankDetails.vue?vue&type=script&lang=js"
import style0 from "./editBankDetails.vue?vue&type=style&index=0&id=38b8489a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b8489a",
  null
  
)

export default component.exports